module.exports = __webpack_public_path__ + "static/media/goodbeep.a5873799.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/goodbeep.wav
// module id = 2832
// module chunks = 0